//
// CADUCIDADES
//
var COLS = 13; // columnas de la matriz

var ROWS = 13; // filas de la matriz
// array de caraceres disponibles (el producto de rows·cols debe ser su longitud)

var BETA = [" ", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "ñ", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "á", "à", "â", "ä", "ã", "å", "é", "è", "ê", "ë", "í", "ì", "î", "ï", "ó", "ò", "ô", "ö", "õ", "ú", "ù", "û", "ü", "ç", "ÿ", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "Ñ", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "Á", "À", "Â", "Ä", "Ã", "Å", "É", "È", "Ê", "Ë", "Í", "Ì", "Î", "Ï", "Ó", "Ò", "Ô", "Ö", "Õ", "Ú", "Ù", "Û", "Ü", "Ç", "Ÿ", "ª", "º", "!", "|", "@", "·", "#", "$", "%", "&", "¬", "/", "(", ")", "=", "'", "?", "¡", "¿", "[", "]", "+", "*", "{", "}", ",", ";", ".", ":", "_", "<", ">", "€", "†", "‡", "~", "÷", "¯", "²", "³", "¼", "½", "¾", "£", "¢", "§", "©", "®", "æ", "ß", "ø", "Æ", "Œ", "-"];
var LSAL = 2;
var PASS = "";
var MARCA_SALTO_DE_LINEA = "¤";
var CODIGO_MARCA_SALTO_DE_LINEA = 164;
var SALTO_DE_LINEA = "\r";
var CODIGO_SALTO_DE_LINEA = 13;
var alpha = [];
var mesg = "";

function inicializar() {
  alpha = [];
  mesg = "";
}
/**
 * Codifica la cadena indicada
 * 
 * @param {string} entrada 
 * @return {string} salida
 */


export function pulsarCodificar(entrada) {
  inicializar();
  var txt = "";

  for (var _w = 0; _w < entrada.length; _w++) {
    txt += entrada.charAt(_w) + BETA[Math.floor(BETA.length * Math.random())]; // + un caracter a azar
  }

  var sal = ""; // factor de azar

  for (var s = 0; s < LSAL; s++) {
    sal += BETA[Math.floor(37 * Math.random()) + 1]; // sólo números o minúsculas (por si se quieren memorizar y extraer del mensaje)
  }

  colocar();
  descolocar(sal); // obliga que la longitud del texto de entrada sea par

  if (Math.ceil(txt.length / 2) !== txt.length / 2) {
    txt += " ";
  } //sustituye los saltos de línea (cod=13) por ¤ (cod=?)


  var ltr1 = void 0;
  var ltr2 = void 0;

  for (var w = 0; w < txt.length; w += 2) {
    if (txt.charCodeAt(w) === CODIGO_SALTO_DE_LINEA) {
      ltr1 = MARCA_SALTO_DE_LINEA;
    } else {
      ltr1 = txt.charAt(w);
    }

    if (txt.charCodeAt(w + 1) === CODIGO_SALTO_DE_LINEA) {
      ltr2 = MARCA_SALTO_DE_LINEA;
    } else {
      ltr2 = txt.charAt(w + 1);
    }

    codificar(ltr1, ltr2);
  }

  var salida = "";

  if (mesg.length > 0) {
    salida = sal + mesg;
  }

  return salida;
}

function codificar(ltr1, ltr2) {
  //recoje las coordenadas de los pares de letras (a,b y c,d)
  var _leertxt = leertxt(ltr1, ltr2),
      a = _leertxt.a,
      b = _leertxt.b,
      c = _leertxt.c,
      d = _leertxt.d; //si pertenecen a la misma fila...


  if (a === c) {
    if (b === COLS - 1 && d === COLS - 1) {
      //.. los dos son el mismo carácter
      mesg += alpha[COLS * a + b + 1 - COLS] + alpha[COLS * c + d + 1 - COLS]; // = el primero de esa fila
    } else if (b === COLS - 1) {
      // ... el primer carácter es el último de la fila
      mesg += alpha[COLS * a + b + 1 - COLS] + alpha[COLS * c + d + 1]; // = al primero de la fila
    } else if (d === COLS - 1) {
      //idem el segundo
      mesg += alpha[COLS * a + b + 1] + alpha[COLS * c + d + 1 - COLS];
    } else {
      mesg += alpha[COLS * a + b + 1] + alpha[COLS * c + d + 1]; // ... se remplazan por los de su derecha
    }
  } else if (b === d) {
    //si pertenecen a la misma columna...
    if (a === ROWS - 1) {
      // ... el primer carácter es el último de la columna
      mesg += alpha[COLS * (a + 1 - ROWS) + b] + alpha[COLS * (c + 1) + d]; // = al primero de la columna
    } else if (c === ROWS - 1) {
      //idem el segundo
      mesg += alpha[COLS * (a + 1) + b] + alpha[COLS * (c + 1 - ROWS) + d];
    } else {
      mesg += alpha[COLS * (a + 1) + b] + alpha[COLS * (c + 1) + d]; // ... se remplazan por los de abajo
    }
  } else {
    mesg += alpha[COLS * a + d] + alpha[COLS * c + b]; // si no son de la misma fila o columna, se transponen las coord.
  }
}
/**
 * Descodifica la cadena indicada
 * 
 * @param {string} entrada 
 * @return {string} salida
 */


export default function pulsarDescodificar(entrada) {
  inicializar();
  var txt = entrada;
  var sal = txt.charAt(0) + "" + txt.charAt(1);
  colocar();
  descolocar(sal);

  if (Math.ceil(txt.length / 2) !== txt.length / 2) {
    txt += " ";
  }

  for (var w = 0; w < txt.length; w += 2) {
    var ltr1 = txt.charAt(w);
    var ltr2 = txt.charAt(w + 1);
    descodificar(ltr1, ltr2);
  }

  var mesgt = mesg.substr(2);
  mesg = ""; // sustituir saltos de línea	

  for (var _w2 = 0; _w2 < mesgt.length; _w2 += 1) {
    if (mesgt.charCodeAt(_w2) === CODIGO_MARCA_SALTO_DE_LINEA) {
      mesg += SALTO_DE_LINEA;
    } else {
      mesg += mesgt.charAt(_w2);
    }
  }

  var salida = "";

  for (var _w3 = 0; _w3 < mesg.length; _w3 += 2) {
    // se salta el caracter al azar
    salida += mesg.charAt(_w3);
  }

  return salida;
}

function descodificar(ltr1, ltr2) {
  var _leertxt2 = leertxt(ltr1, ltr2),
      a = _leertxt2.a,
      b = _leertxt2.b,
      c = _leertxt2.c,
      d = _leertxt2.d;

  if (a === c) {
    if (b === 0 && d === 0) {
      mesg += alpha[COLS * a + b - 1 + COLS] + alpha[COLS * c + d - 1 + COLS];
    } else if (b === 0) {
      mesg += alpha[COLS * a + b - 1 + COLS] + alpha[COLS * c + d - 1];
    } else if (d === 0) {
      mesg += alpha[COLS * a + b - 1] + alpha[COLS * c + d - 1 + COLS];
    } else {
      mesg += alpha[COLS * a + b - 1] + alpha[COLS * c + d - 1]; // idem codificar, pero se sustituye por los de la izq.
    }
  } else if (b === d) {
    if (a === 0) {
      mesg += alpha[COLS * (a - 1 + ROWS) + b] + alpha[COLS * (c - 1) + d];
    } else if (c === 0) {
      mesg += alpha[COLS * (a - 1) + b] + alpha[COLS * (c - 1 + ROWS) + d];
    } else {
      mesg += alpha[COLS * (a - 1) + b] + alpha[COLS * (c - 1) + d]; // idem codificar, pero se sustituye por los de arriba
    }
  } else {
    mesg += alpha[COLS * a + d] + alpha[COLS * c + b];
  }
} // recoje las coordenadas de los pares de letras


function leertxt(ltr1, ltr2) {
  var a = void 0;
  var b = void 0;
  var c = void 0;
  var d = void 0;

  for (var i = 0; i < ROWS; i++) {
    for (var j = 0; j < COLS; j++) {
      if (ltr1 === alpha[COLS * i + j]) {
        a = i;
        b = j;
      }
    }
  }

  for (var _i = 0; _i < ROWS; _i++) {
    for (var _j = 0; _j < COLS; _j++) {
      if (ltr2 === alpha[COLS * _i + _j]) {
        c = _i;
        d = _j;
      }
    }
  }

  return {
    a: a,
    b: b,
    c: c,
    d: d
  };
}

function colocar() {
  alpha = [].concat(BETA); // for(var i = 0; i < BETA.length; i++) {
  //     // matriz alpha(la que se utiliza para la cod/decod) se iguala por la beta (la lista de caracteres original)
  // 	alpha[i] = BETA[i]
  // }
}

function descolocar(sal) {
  var sum = 0; //sum es la suma de los códigos de los caracteres de la contraseña

  var pw = new Array(PASS.length); // array donde se guardarán los caracteres la contraseña

  var pcod = new Array(PASS.length); // array donde se guardarán los códigos la contraseña

  for (var w = 0; w < pw.length; w++) {
    // rellenar estos arrays y realizar la suma
    pw[w] = PASS.charAt(w);
    pcod[w] = PASS.charCodeAt(w);
    sum += PASS.charCodeAt(w);
  }

  var pl = pw.length;

  for (var u = 0; u < sal.length; u++) {
    pw[u + pl] = sal.charAt(u);
    pcod[u + pl] = sal.charCodeAt(u);
    sum += sal.charCodeAt(u);
  } //se colocan los caracteres de la contraseña en las primeras celdas de la matriz	


  for (var _w4 = 0; _w4 < pw.length; _w4++) {
    for (var i = 0; i < ROWS; i++) {
      for (var j = 0; j < COLS; j++) {
        if (pw[_w4] === alpha[COLS * i + j]) {
          alpha[COLS * i + j] = alpha[_w4];
          alpha[_w4] = pw[_w4];
        }
      }
    }
  } // número de desfase (del 1 al 5) obtenido a partir de la suma de la contraseña 


  var des = parseInt(1 + Math.ceil((Math.ceil(sum / Math.PI) - sum / Math.PI) * 4));

  for (var _w5 = 0; _w5 < pw.length; _w5 += 2) {
    // barrido de la contraseña de 2 en 2 para utilizar el dos códigos (char. posición w y char. pos. w+1) uno para filas y otro para columnas
    for (var _i2 = 0; _i2 < ROWS; _i2++) {
      var a = Math.round((Math.ceil(pcod[_w5] / ROWS) - pcod[_w5] / ROWS) * ROWS); // número del 0 al nº de filas

      if (_i2 + a >= ROWS) {
        //renumeración de las filas que se saldrían de la matriz
        a -= ROWS;
      }

      for (var _j2 = 0; _j2 < COLS; _j2 += des) {
        var b = Math.round((Math.ceil(pcod[_w5 + 1] / COLS) - pcod[_w5 + 1] / COLS) * COLS); // número del 0 al nº de columnas

        if (_j2 + b >= COLS) {
          //renumeración de las columnas que se saldrían de la matriz
          b -= COLS;
        }

        var c = alpha[COLS * _i2 + _j2]; // intercambio de la celda i,j por la a,b

        alpha[COLS * _i2 + _j2] = alpha[COLS * (_i2 + a) + _j2 + b];
        alpha[COLS * (_i2 + a) + _j2 + b] = c;
      }
    }
  }
}